import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
export const actionTypes = {
  HANDLE_GET_NODE_CONFIGURATION: "[HANDLE_GET_NODE_CONFIGURATION] Action",
  CLONE_NODE: "[CLONE_NODE] Action",
  DELETE_NODE: "[DELETE_NODE] Action",
};

const initialState = {
  nodeDetails: { data: {}, isSidebarOpen: false },
  cloneNode: { data: {} },
  deleteNode: { data: {} },
};

export const reducer = persistReducer(
  { storage, key: "nodeData", blacklist: [] },
  (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.HANDLE_GET_NODE_CONFIGURATION:
        return {
          ...state,
          nodeDetails: action.payload,
        };
      case actionTypes.CLONE_NODE:
        return {
          ...state,
          cloneNode: action.payload,
        };
      case actionTypes.DELETE_NODE:
        return {
          ...state,
          deleteNode: action.payload,
        };
      default:
        return state;
    }
  }
);

export const NodeAction = {
  TOGGLE_HANDLE_GET_NODE_CONFIGURATION: (payload) => ({
    type: actionTypes.HANDLE_GET_NODE_CONFIGURATION,
    payload,
  }),
  TOGGLE_CLONE_NODE: (payload) => ({
    type: actionTypes.CLONE_NODE,
    payload,
  }),
  TOGGLE_DELETE_NODE: (payload) => ({
    type: actionTypes.DELETE_NODE,
    payload,
  }),
};
